import ProfileTop from "../components/ProfileTop/ProfileTop"
import ProfileAssets from "../components/ProfileAssets"
import AboutAuthor from "../components/AboutAithor/AboutAuthor";
import SharePage from "../components/SharePage/SharePage";
import PaymentSuccessHandler from "../components/PaymentSuccessHandler";

import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchUserProfile } from "../store/slices/profileSlice";
import { useNavigate } from "react-router-dom";

const Profile=()=>{

  const dispatch = useDispatch()
  const {profile, status} = useSelector(state=> state.profile)
  const navigate = useNavigate();

  useEffect(()=>{
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    dispatch(fetchUserProfile())
  },[dispatch])

  useEffect(() => {
    document.title = "Distortion Grids Database - Profile";
    
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.content = "Distortion Grids Database - Profile";
    }
  }, []);

  useEffect(() => {
    if(status.fetchUserProfileStatus === "failed"){
      navigate("/authorization");
    }
  }, [status.fetchUserProfileStatus, navigate])

  return (
    <PaymentSuccessHandler>
      <>
        <ProfileTop 
          profile={profile || {}} 
          status={status} 
        />
        <ProfileAssets />
        {profile?.about_me && <AboutAuthor about={profile.about_me}/>}
      </>
    </PaymentSuccessHandler>
  );
}

export default Profile